import { Link, Text } from '@joor/design-system'
import styled from 'styled-components'

import messages from '../../BrandStartOrderModal.messages'

const HELP_CENTER_URL =
  'https://help.jooraccess.com/hc/en-us/articles/51727764272795-Quick-Start-Orders'

export const MessageBox = () => (
  <BoxContainer>
    <Text letterSpacing="normal" color="primary-700" fontSize="small">
      <strong>{messages.noConnection}</strong>
      {messages.startOrderAnyway}
      <Link
        href={HELP_CENTER_URL}
        target="_blank"
        fontSize="small"
        letterSpacing="normal"
      >
        {messages.learnMore}
      </Link>
    </Text>
  </BoxContainer>
)

const BoxContainer = styled.div`
  background-color: var(--color-secondary-200);
  border-radius: var(--size-border-radius-medium);
  padding: 16px 20px;
  margin-bottom: 20px;
  margin-left: -16px;
  margin-right: -16px;
`
